import { loadMongoData } from '@adornis/baseql/server/data-loader.js';
import { getPluginForScope } from '@adornis/buchungsheld-db/plugins/plugin.js';
import { BHPayment } from './entities/BHPayment.js';

export const createPayment = async (institutionID: string, participationIDs: string[], paymentMethod: string) => {
  // check if participation is already paid
  const payments = await loadMongoData(BHPayment, { participationIDs: { $in: participationIDs } });
  for (const payment of payments) {
    if (payment.status === 'paid')
      throw new Error(
        'cant create payment; participations ' + payment.participationIDs.join(', ') + ' are already paid',
      );
  }

  // call payment plugin
  const paymentPlugin = getPluginForScope('payment', institutionID);
  return paymentPlugin.createPayment(participationIDs, paymentMethod);
};
